import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';

interface attributeMappingConfigInfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class AttributeMappingConfigService {

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(
      private http: HttpClient,
      private snackBar: MatSnackBar,
      private spinner: NgxUiLoaderService, 
      private restAPI: RestApi
    ) { }

    createMappingAttributes(mappingAttribute,mappingAttributesId){
      return this.http.post<attributeMappingConfigInfo>(this.restAPI.CREATE_MAPPING_ATTRIBUTES+"/"+mappingAttributesId,JSON.stringify(mappingAttribute), { headers: this.headers })
    }

    retreiveMappingAttributes(tenantId) {
      return this.http.get<attributeMappingConfigInfo>(this.restAPI.RETRIEVE_MAPPING_ATTRIBUTES+"/"+tenantId, { headers: this.headers })
    }
  
    deleteMappingAttributes(mappingAttributeId) {
      return this.http.delete<attributeMappingConfigInfo>(this.restAPI.DELETE_MAPPING_ATTRIBUTES+"/"+mappingAttributeId, { headers: this.headers })
    }

    validateSQLQuery(sqlQueryBody){
      return this.http.post<attributeMappingConfigInfo>(this.restAPI.VALIDATE_SQL_QUERY,JSON.stringify(sqlQueryBody), { headers: this.headers })
    }

    generateNewMappingFileVersion(tenantId,snapshotName){
      return this.http.post<attributeMappingConfigInfo>(this.restAPI.GENERATE_NEW_MAPPING_FILE_VERSION+"/"+tenantId+"/"+snapshotName, { headers: this.headers })
    }

    retreiveMappingBaselineDetails(tenantId) {
      return this.http.get<attributeMappingConfigInfo>(this.restAPI.GET_MAPPING_BASELINE_DETAILS+"/"+tenantId, { headers: this.headers })
    }

    updateAttibuteSatus(requestbody,Attibutes){
      return this.http.post<attributeMappingConfigInfo>(this.restAPI.UpdateAttributeStatus+"/"+Attibutes,JSON.stringify(requestbody), { headers: this.headers })
    }
  
    mappingSourceAndTargetObjects(mappingDto){
      return this.http.post<attributeMappingConfigInfo>(this.restAPI.BATCH_INSERT_MAPPING_CONFIGURATION,mappingDto, { headers: this.headers })
    }

    retrivemappingtestbedexecution(WorkspaceId){
      return this.http.get<attributeMappingConfigInfo>(this.restAPI.retrivemappingtestbedexecution+"/"+WorkspaceId, { headers: this.headers })
    }

     deleteMultipleMappingAttributes(mappingAttributeList) {
          const options = {
              headers: this.headers,
              body: mappingAttributeList
            };
            return this.http.delete<attributeMappingConfigInfo>(
              this.restAPI.DELETE_MULTIPLE_MAPPING_ATTRIBUTES,
              options
            );
    }
    
}
 